"use strict";
// Import bootstrap asynchronously to ensure shared dependencies are loaded
console.log('INDEX LOADED');
import('./bootstrap');
